export const INSTANCE_MEMBERSHIP_STATUS = {
	ADMIN: "admin",
	MEMBER_OF_INSTANCE: "memberOfInstance",
	WAITING_APPROVAL_OF_INSTANCE: "waitingApprovalOfInstance",
	NOT_MEMBER_OF_INSTANCE: "notMemberOfInstance",
};

export const RECORDING_MAX_FREE_DURATION = 5 * 60 * 1000; // 5 minutes

// Notification-center event gating all what's-new announcements (default on).
export const WHATS_NEW_NOTIFICATION_EVENT = "WHATS_NEW";

export const ACCOUNT_CONFIGURATION_UPDATED = "account-configuration-updated";

export const WEVIDEO_PLANS = {
	FREE_PLAN: "wv_free",
	POWER_PLAN_M: "wv_single_1m",
	POWER_PLAN_Y: "wv_single_12m",
	UNLIMITED_PLAN_M: "wv_unloct17_1m",
	UNLIMITED_PLAN_Y: "wv_unloct17_12m",
	PROFESSIONAL_PLAN_M: "wv_bizindiv_1m",
	PROFESSIONAL_PLAN_Y: "wv_bizindiv_12m",
	BUSINESS_PLAN_Y: "wv_bizoct17_12m",
	BUSINESS_PLAN_M: "wv_bizoct17_1m",
	BUSINESS_PLAN_TRIAL: "wv_bizoct17_trial",
	FLEX_PLAN: "wv_flex2",
	SINGLE_PLUS_PLAN: "single_plus",
	EDUCATION_TRIAL: "wv_edu_trial",
	PROFESSIONAL_TRIAL: "wv_bizindiv_trial",
	EDUCATION_K12_PLAN_Y: "wv_k12_12m",
	EDUCATION_K12_PLAN_M: "wv_k12_1m",
	EDUCATION_TEACHER_PLAN_Y: "wv_teacher_12m",
	UNLIMITED_PLAN_TRIAL: "wv_unlimited_trial",
	INDIVIDUAL_PLAN_M: "wv_individual_1m",
	INDIVIDUAL_PLAN_Y: "wv_individual_12m",
	INDIVIDUAL_PLAN_TRIAL: "wv_individual_trial",
	TEAMS_PLAN_M: "wv_teams_1m",
	TEAMS_PLAN_Y: "wv_teams_12m",
	TEAMS_PLAN_TRIAL: "wv_teams_trial",
};
